export const FETCH_PERMISSION_REQUEST = "FETCH_PERMISSION_REQUEST";
export const FETCH_PERMISSION_SUCCESS = "FETCH_PERMISSION_SUCCESS";
export const FETCH_PERMISSION_FAILURE = "FETCH_PERMISSION_FAILURE";
